import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { RANGER_AVATAR } from "@/lib/constants";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | pending | error
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    if (state !== "checking") return;
    if (tries > 8) { setState("pending"); return; }
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") setState("paid");
        else if (["expired", "failed"].includes(data.payment_status)) setState("error");
        else setTries((n) => n + 1);
      } catch { setTries((n) => n + 1); }
    }, 1800);
    return () => clearTimeout(t);
  }, [sessionId, tries, state]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] grain flex items-center justify-center px-4">
      <div className="relative z-10 border border-white/10 bg-[#141414] p-10 max-w-md text-center" data-testid="payment-result">
        <img src={RANGER_AVATAR} alt="" className="w-16 h-16 object-cover border border-[#FF0055] mx-auto mb-6" />
        {state === "checking" && <><Loader2 className="animate-spin text-[#00E5FF] mx-auto mb-4" /><h1 className="font-display font-bold text-2xl text-white">Confirming your payment...</h1></>}
        {state === "paid" && <><CheckCircle2 className="text-[#00FF66] mx-auto mb-4" size={40} /><h1 className="font-display font-black text-3xl text-white">Welcome aboard!</h1><p className="text-neutral-400 mt-3">Your membership is active. Your listing has been upgraded.</p></>}
        {state === "pending" && <><Loader2 className="text-[#FFEA00] mx-auto mb-4" /><h1 className="font-display font-bold text-2xl text-white">Payment processing</h1><p className="text-neutral-400 mt-3">This can take a moment. Your dashboard will update shortly.</p></>}
        {state === "error" && <><XCircle className="text-[#FF0055] mx-auto mb-4" size={40} /><h1 className="font-display font-bold text-2xl text-white">We couldn't confirm payment</h1><p className="text-neutral-400 mt-3">If you were charged, it will reflect shortly.</p></>}
        <Link to="/owner"><button className="mt-8 bg-[#FF0055] hover:bg-[#ff2d74] text-white font-semibold px-6 py-3 flex items-center gap-2 mx-auto" data-testid="back-to-dashboard">Go to Dashboard <ArrowRight size={16} /></button></Link>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] grain flex items-center justify-center px-4">
      <div className="relative z-10 border border-white/10 bg-[#141414] p-10 max-w-md text-center">
        <XCircle className="text-neutral-500 mx-auto mb-4" size={40} />
        <h1 className="font-display font-bold text-2xl text-white">Checkout canceled</h1>
        <p className="text-neutral-400 mt-3">No charge was made. You can upgrade any time.</p>
        <Link to="/owner"><button className="mt-8 bg-[#FF0055] hover:bg-[#ff2d74] text-white font-semibold px-6 py-3 mx-auto" data-testid="back-to-dashboard">Back to Dashboard</button></Link>
      </div>
    </div>
  );
}
